module.exports = __webpack_public_path__ + "assets/images/sandra-davie.png?v=4ae03d0b";